import {IOwayoDataModel} from "./model";
import {SessionController} from "../global/SessionController";

import {EventListener, EventVerteiler} from "../global/eventVerteiler";
import {INTERFRAMEMESSAGES} from "../global/InterframeMessages";
import {ErrorHandler, ErrorInfo} from "../global/ErrorHandler";
import {Entwurf} from "./entwurfsObjekt";
import {Z_OrderTable} from "./zOrderTable";
import {EntwurfInitialisator} from "./entwurfInitialisator";
import {Logo, SelectableObject, TextObject} from "./selectableObjects";
import {PatternEntwurfsobjektInteractor, PatternInEntwurf} from "./pattern/patternEntwurfsobjektInteractor";
import {DruckbereichSelObLoescher} from "./controllerModules/druckbereichSelObLoescher";
import {SelObController} from "./controllerModules/selObController";
import {ColorController, EntwurfTransferStorageColor} from "./controllerModules/colorController";
import {ResourceInvalidationTriggers} from "../global/resourcemanager/resourceManager";
import {LoginSuccessfulResult} from "./account/accountController";
import {HTMLPrinter} from "../global/htmlprinter";
import {LogoPoolController} from "./controllerModules/logoPoolController";
import {ContentWithLevel, GetParametersDecoded} from "./delme_globals";
import {CONTROLLER_EVENTNAMES, SELOBEVENTNAMES} from "../global/GlobalEventnames";
import {EntwurfFromDB, Produktresponse} from "./databaseInterfaceClasses";
import {Product, SelectedFeature} from "./product";
import {EinzelExemplar} from "../global/einzelexemplare/einzelExemplarObject";
import {globalsObject} from "./globalsObject";
import {ReadyDesignLoader} from "./controllerModules/readyDesignLoader";
import {Linkersteller} from "./controllerModules/Linkersteller";
import {translate} from "./globalsObject";
import {loadproduktPhpAndRegisterResource} from "../global/produktphpConnector";
import {getGetParameterString, sendPostRequest} from "../global/axiosFormWrapper";
import {deepCopy} from "../global/deepCopy";
import {AutomaticFeatureChanger} from "./controllerModules/automaticFeatureChanger";
import {existsLastLoggedInUserCookie, getURLPrefixOfflineVsOnline} from "../global/globalUtils";
import {arrayElementByKeyValue, arrayIndexByKeyValue} from "../global/arrayHelper";
import {IResourceManager} from "../global/resourcemanager/IResourceManager";
import {CONSTANTS} from "./meta_data";
import axios from "axios";
import {Color} from "@k/js/colorObject";

export class EntwurfTransferStorage {
    colorObjects:EntwurfTransferStorageColor[] = [];
    textObjects:TextObject[]= [];
    logoObjects:Logo[]=[];
    design= "";
    isProcessed= false;
    zOrderTable : Z_OrderTable|null = null;
    exemplarListe = [] as EinzelExemplar[];
    patterns:PatternInEntwurf[] = [];
    features=[];
    partSizes= [];
    vorbelegungsChromoLogoColors = [] as {chromoLogoId:string, colors:any[]}[];
    ordertype= "";
    rdyDesignID= "";
    herstellerlogosEntfernt=false;
}
import {usePalettenClusterStore} from "@k/vue/store/palettenClusterStore";
import {owayoUtils} from "./owayoUtils";
import type {GoogleTracker} from "@k/global/googleTrackerObject";
import {LOOPTRACKINGEVENTNAMES} from "@k/global/loopTracker";


export interface IEntwurfTransferProvider {
    getEntwurfTransferStorage():EntwurfTransferStorage;
    setEntwurftransferStorage(entwurfTransferStorage:EntwurfTransferStorage):void;
}

export interface CurrentOwayProductProvider {
    getCurrentOwayoProduct():Product;
}

export class EntwurfTransferProvider implements IEntwurfTransferProvider{
    private storage: EntwurfTransferStorage;

    public constructor() {
        this.storage = new EntwurfTransferStorage();
    }

    getEntwurfTransferStorage(): EntwurfTransferStorage {
        return this.storage;
    }

    setEntwurftransferStorage(entwurfTransferStorage: EntwurfTransferStorage) {
        this.storage = entwurfTransferStorage;
    }

}

export interface controllerFor3DViewer extends IEntwurfTransferProvider {
    getLoadDesignData():{ features: SelectedFeature[]; design: string; model: string; schnitt: any, herstellerlogosEntfernt:boolean };
    saveEntwurfPreviewPics(snapshots, callback):void;
    checkAllColorsAndChangeChromoLogoIfNecessary():void;
    getEntwurfColorObjects():Color[];
    getLanguageIso():string;
}

export class Controller extends EventListener implements controllerFor3DViewer, CurrentOwayProductProvider{

    public isKundenKonfi = false;
    public firstLoad = true;
    public colorController: ColorController;
    public selObController: SelObController;
    public logoPoolController: LogoPoolController;
    public globalLoginCallback;
    private patternController: PatternEntwurfsobjektInteractor;
    private druckBereichSelObDeleter : DruckbereichSelObLoescher;
    private entwurfTransferStorageProvider: IEntwurfTransferProvider;
    private infoFromGetParameters: GetParametersDecoded;
    public model : IOwayoDataModel;
    private readonly tracker: GoogleTracker|null = null;
    // private readonly logoPoolFactory: () => ILogoPoolStore;

    private static errorHandler:ErrorHandler;
    public static resourceManager:IResourceManager;

    constructor(
        model: IOwayoDataModel,
        entwurfTransferStorageProvider:IEntwurfTransferProvider,
        infoFromGetParameters :GetParametersDecoded,
        tracker:GoogleTracker|null=null
    ) {
        super();
        this.model = model;
        this.tracker = tracker;
        // this.logoPoolFactory = logoPoolFactory;
        this.entwurfTransferStorageProvider = entwurfTransferStorageProvider;
        this.infoFromGetParameters = infoFromGetParameters;
        this.entwurfTransferStorageProvider.getEntwurfTransferStorage().isProcessed = true;
        this.initEventHandlers();
        this.colorController = new ColorController(model, this.tracker);
        this.selObController = new SelObController(model, entwurfTransferStorageProvider, this.tracker);
        this.logoPoolController = new LogoPoolController(model)
        this.patternController = new PatternEntwurfsobjektInteractor(model, nr=>this.getColorCodeFromColorCodeNr(nr));
        this.druckBereichSelObDeleter = new DruckbereichSelObLoescher();
    }

    getLanguageIso() {
        return this.model.getLanguageIso();
    }

    public static setErrorHandler = (errorHandler:ErrorHandler)=>Controller.errorHandler = errorHandler;
    public static setResourcemanager = (resourcemanager:IResourceManager)=>Controller.resourceManager = resourcemanager;


    private trackpageView(page) {
        if (this.tracker !== null) {
            this.tracker.trackPageview(page);
        }
    }

    private trackAtFB(page:string) {
        if(this.tracker !== null) {
            this.tracker.trackFbq(page);
        }
    }
    public colorToDisplayIsVisible(colorCode) {
        return this.colorController.colorToDisplayIsVisible(colorCode);
    }

    public getCurrentOwayoProduct() {
        return this.model.getCurrentOwayoProduct();
    }

    public getEntwurfTransferStorage(): EntwurfTransferStorage {
        return this.entwurfTransferStorageProvider.getEntwurfTransferStorage();
    }

    private initAutomaticFeatureChanger() {
        const produktPHPDate = Controller.resourceManager.getResourceByName("produkt.php").data;
        EventVerteiler.unsubscribe(this.model.getCurrentOwayoProduct().automaticfeatureController as EventListener);
        if(typeof(produktPHPDate.bwVeredelungsFeaturedObjects) !== "undefined" && produktPHPDate.bwVeredelungsFeaturedObjects.length >0) {
            this.model.getCurrentOwayoProduct().automaticfeatureController = new AutomaticFeatureChanger(this, produktPHPDate.bwVeredelungsFeaturedObjects);
        } else {
            this.model.getCurrentOwayoProduct().automaticfeatureController = null;
        }
    }
    public setEntwurftransferStorage(entwurfTransferStorage: EntwurfTransferStorage) {
        this.entwurfTransferStorageProvider.setEntwurftransferStorage(entwurfTransferStorage);
    }

    getEntwurfColorObjects() {
        return this.model.entwurf.getColorObjects();
    }

    public checkAllColorsAndChangeChromoLogoIfNecessary = ()=>this.colorController.checkAllColorsAndChangeChromoLogoIfNecessary();
    public requestCurrentDesign = ()=>this.model.entwurf.getDesign();
    public entwurfNeedsSaving = ()=>this.model.entwurf.getChangedSinceSave();
    private savePartSizeInfoInTransferStorage = partSizesCM=>this.getEntwurfTransferStorage().partSizes = partSizesCM;
    private static showThatModelRotates = ()=>EventVerteiler.broadcast("doABarrelRollEvent");

    public initNewEntwurf(productCategory:string, designName:string, model:string, tryNumber=0) {
        const entwurfInitialisator = new EntwurfInitialisator(this.model, this.isKundenKonfi, this.infoFromGetParameters.motiv, this.infoFromGetParameters.productcolor);
        entwurfInitialisator.initNewEntwurf(productCategory, designName, model, this.getEntwurfTransferStorage(), tryNumber);
        this.initAutomaticFeatureChanger();
        this.showOrHideTrikotWendeButton();
    };

    private showOrHideTrikotWendeButton() {
        EventVerteiler.broadcast("wendefunktionalitaetVerfuegbarkeit", this.model.getCurrentOwayoProduct().selectedFeatures.find(sf => sf.feature === "Wendbar") !== undefined);
    }

    public initLoadedEntwurf(data:EntwurfFromDB,saveId) {
        if(this.model.getKundenKonfi()!==""){
            this.isKundenKonfi = true;
        }
        const entwurfInitialisator = new EntwurfInitialisator(this.model, this.isKundenKonfi);
        entwurfInitialisator.initLoadedEntwurf(data, saveId, this.getEntwurfTransferStorage());
        this.initAutomaticFeatureChanger();
        this.showOrHideTrikotWendeButton();
    };

    public displayDialogWithSpamfolderWarning(dialogName) {
        const p = HTMLPrinter;
        const emailWarning = p.collection(p.br, p.strong(translate("konf_warnAboutSpamFolder", "")));
        EventVerteiler.broadcast("displayDialogEvent", {dialog: dialogName, messageAddition : emailWarning});
    }

    public handleError = (severity, happenedHere, messageToDisplay, callbackAfterMessageClose?)=>Controller.errorHandler.handleError(severity, happenedHere, messageToDisplay, callbackAfterMessageClose);

    private initEventHandlers() {
        this
            .addEventListener(INTERFRAMEMESSAGES.USERMANAGEMENT_LOGIN_SUCCESS, (data:LoginSuccessfulResult)=>this.userLoginSuccessful(data.username, data.loginResponse, data.callback))
            .addEventListener(INTERFRAMEMESSAGES.LOGOUT_SUCCEEDED, (newTempUsername)=>this.userLoggedOut(newTempUsername))
            .addEventListener(INTERFRAMEMESSAGES.USERMANAGEMENT_REGISTRATION_SUCCESS, (username)=>this.userRegistrationSuccessful(username))
            .addEventListener(INTERFRAMEMESSAGES.LOGOUT_FAILED, ()=>this.handleError("ajaxFail", "logout",translate("konf_logoutFailed")))
            .addEventListener("einzelexemplareChanged", (data)=>this.einzelexemplareChanged(data.saveID, data.exemplare))
            .addEventListener("featureChangeEvent", (data)=>this.changeFeature(data.foName, data.feature))
            .addEventListener("checkAllColorsAndChangeChromoLogoIfNecessaryEvent", ()=>this.checkAllColorsAndChangeChromoLogoIfNecessary())
            .addEventListener(CONTROLLER_EVENTNAMES.ERROR, (error:ErrorInfo)=>this.handleError(error.severity, error.happenedHere, error.messageID, error.callbackAfterMessageClose))
            .addEventListener("changeDesignRequestEvent", (data:{designname:string, byHistoryController?:boolean})=>this.changeDesign(data.designname,  data.byHistoryController))
            .addEventListener("loadLogoPoolEvent", ()=>this.model.logoPool.loadLogoPool())
            .addEventListener("PartsWurdenAusgeblendetEvent", ({invisibleParts})=>{
                this.deleteSelectableObjectsOnInvisibleParts(invisibleParts)
            })
            .addEventListener(SELOBEVENTNAMES.INSERTED, ()=>this.pruefeAufAILogoFuerPreiswechsel())
            .addEventListener(SELOBEVENTNAMES.DELETED, ()=>this.pruefeAufAILogoFuerPreiswechsel())
            .addEventListener("IncrementAICreditsUsed", ()=>this.model.user.incrementAiLogoCreditsUsed())
            .addEventListener("savePreviewPics", (screenshots: any)=>this.saveEntwurfPreviewPics(screenshots, null))
    }

    private changeFeature(foName:string, feature:string) {
        const selectedFeature = this.model.getCurrentOwayoProduct().selectedFeatures.find(f=>f.featuredObject === foName) as SelectedFeature;

        if(typeof(selectedFeature)==="undefined"){
            return;
        }

        const setfeature = (fo: SelectedFeature, featurename: string)=>{
            fo.feature = featurename;
            fo.name = featurename
        }

        if(selectedFeature.feature === feature) {
            return;
        }
        setfeature(selectedFeature, feature);
        // setfeature(this.model.productStage.selectedFeatures.find(f=>f.featuredObject === foName), feature);
        this.featureChangedDuringDesignprocess();
    }

    private pruefeAufAILogoFuerPreiswechsel(){
        let featuredObject = 'Bedruckung KI Logo';
        let feature = 'ohne KI Logo';

        if(arrayIndexByKeyValue(this.model.entwurf.getLogoObjects(), 'isAILogo', true)>=0){
            feature = 'mit KI Logo';
        }

        this.changeFeature(featuredObject, feature);
    }

    private featureChangedDuringDesignprocess() {
        const message = translate("konf_bedruckung_geandert");
        if(message === "konf_bedruckung_geandert" || message === "[]") {
            EventVerteiler.broadcast("displayHintEventToBeTranslated", {message:"konf_bedruckung_geandert"});
        } else {
            EventVerteiler.broadcast("displayHintEvent", {message: message})
        }

        EventVerteiler.broadcast("getPreisEvent");
        EventVerteiler.broadcast("updateTitelTagEvent", {product:this.model.getCurrentOwayoProduct(), design:this.model.entwurf.getDesign()})
    }

    loadAdressen() {
        this.model.user.loadAdressen();
    }

    private createInitColorsTask() {
        const $this = this;
        Controller.resourceManager.createTask("initColorsAfterLogin")
            .withContext(this)
            .discardAfterExecution()
            .when("entwurfInitialized", "done")
            .thenDo(
                function () {
                    $this.colorController.broadcastInitColorsEvent();
                    $this.globalLoginCallback=null;
                }
            );
    }

    userLoginSuccessful(username, loginData, callback?) {
        Controller.resourceManager.executeInvalidation(ResourceInvalidationTriggers.USERCHANGED);
        const palettenClusterStore = usePalettenClusterStore();
        palettenClusterStore.clear();
        this.model.user.userLoggedIn(username, loginData);
        this.model.setLieferland(loginData.lieferland !== null ? loginData.lieferland : this.model.getLand());
        EventVerteiler.broadcast("lieferlandChangedEvent", {lieferland:this.model.getLieferland()});

        if (loginData.rabattCode !== "") {
            this.model.setGlobalRabattCode(loginData.rabattCode);
        }

        EventVerteiler.broadcast("getPreisEvent", {});
        this.trackpageView("konfiaccess/3Dlogingetaetigt.htm");
        globalsObject.loopTracker.trackBasicEvent(LOOPTRACKINGEVENTNAMES.ACCOUNT_LOGIN);
        EventVerteiler.broadcast("userLoggedInEvent", {username: username});
        EventVerteiler.broadcastBlockRequestEnded("login");

        if (typeof (callback) === "function") {
            callback();
        }

        if (typeof (this.globalLoginCallback) === "function") {
            this.globalLoginCallback();
        }
        this.createInitColorsTask();

        const $this = this;
        Controller.resourceManager.createTask("initColorsAfterLoginAlternative")
            .withContext(this)
            .invalidAfter("colorsInitializingAfterLogin")
            .when("loadInitialProduct", "done").andWhen("dataModel", "entwurf toBeNotEmpty")
            .thenDo(
                function () {
                    $this.colorController.broadcastInitColorsEvent();
                    $this.globalLoginCallback=null;
                    Controller.resourceManager.executeInvalidation("colorsInitializingAfterLogin");
                }
            );
    }

    userLoggedOut(newTempUsername) {
        Controller.resourceManager.executeInvalidation(ResourceInvalidationTriggers.USERCHANGED);
        const palettenClusterStore = usePalettenClusterStore();
        palettenClusterStore.clear();
        this.model.user.userLoggedOut(newTempUsername);
        this.model.setLieferland(this.model.getLand());
        EventVerteiler.broadcast("lieferlandChangedEvent", {lieferland:this.model.getLand()});
        this.selObController.deleteAllSelObs();
        EventVerteiler.broadcast("userLoggedOutEvent");
        this.initNewEntwurf(this.model.entwurf.getProductCategory(), this.model.entwurf.getDesign(), this.model.entwurf.getModel());
        EventVerteiler.resourceManager.createTask("initColors")
        EventVerteiler.broadcastBlockRequestEnded("logout");
        this.colorController.broadcastInitColorsEvent();
    }

    private trackAccountCreatedOnFacebook() {
        // @ts-ignore
        if(typeof(fbq) === "function") {
            // @ts-ignore
            // fbq('track', 'CompleteRegistration', {
            //     value: 60.00,
            //     currency: 'EUR',
            //     status: 'completed'
            // });
        }
    }

    private userRegistrationSuccessful(username) {
        this.model.user.userRegistrationSuccessful(username);
        EventVerteiler.broadcast("userLoggedInEvent", {username: username});
        this.trackpageView("3Daccountangelegt"+this.model.getWebsportFuerProduktAuswahlNormalized()+".htm");
        this.tracker.trackBingEvent('signup', {});
        this.trackAccountCreatedOnFacebook();
        globalsObject.loopTracker.trackSignUpEvent();
        EventVerteiler.broadcast("displayHintEvent", {message: translate("konf_hello")+ " "+ username, type:"info"});
        EventVerteiler.broadcast("loginIntoNewAccountEvent", {username: username});
    }

    saveEntwurfPreviewPics(snapshots, callback) {
        const $this = this;
        sendPostRequest("/konfigurator_php/actionmodul/saveScreenshot.php", {img: snapshots, saveId: $this.model.entwurf.getID(), login: $this.model.user.getUserName, renderLevel:CONSTANTS.SNAPSHOT_RENDER_LEVEL_1024_1024})
            .then(response=> {
                if (response.data.success === "false") {
                    $this.handleError("ajaxFail", "saveEntwurfPreviewPics",
                        translate("konf_error_savingDraftPreviewPics", "Verzeihung, ich konnte die Vorschaubilder nicht speichern.")
                        + " error: " + response.data.error);
                } else {
                    if ($this.model.user.getEntwuerfe().length > 1) {
                        EventVerteiler.broadcast("entwurfPreviewPictureSavedEvent", {
                            id: parseInt($this.model.entwurf.getID(), 10),
                            inBasket: $this.model.entwurf.getInBasket()
                        });
                    } else {
                        EventVerteiler.broadcast("updateEntwuerfeEvent", {
                            entwuerfe: $this.model.user.getEntwuerfe(),
                        });
                    }
                }
            }).catch(()=> $this.handleError("ajaxFail", "saveEntwurfPreviewPics",
            translate("konf_error_savingDraftPreviewPics", "Verzeihung, ich konnte die Vorschaubilder nicht speichern.")
        )).finally(()=>{
            if (typeof (callback) === "function") {
                callback();
            }
        })

    }


    extractInformationFromEntwurfForProductChangeWithoutColors() {

        this.model.entwurf.setCloneFlags();
        const storage = new EntwurfTransferStorage();

        storage.design = this.model.entwurf.getDesign();
        storage.logoObjects = Entwurf.dataInteractor.getLogoObjects().filter(logo=>!logo.isClone && !logo.isVorbelegung && !logo.zuLoeschenBeiProduktUndDesignWechsel);
        storage.textObjects = (Entwurf.dataInteractor.getTextObjects() as TextObject[]).filter(text=>!text.isClone && !text.isVorbelegung);
        storage.patterns = Entwurf.dataInteractor.getPatterns().splice(0);
        storage.ordertype = this.model.getCurrentOwayoProduct().ordertype;
        storage.rdyDesignID = Entwurf.dataInteractor.getRdyDesignID();
        storage.herstellerlogosEntfernt = Entwurf.dataInteractor.getHerstellerlogosDeleted();
        Controller.setZOrderInStorage(storage.logoObjects);
        Controller.setZOrderInStorage(storage.textObjects);

        storage.zOrderTable = Entwurf.dataInteractor.getZOrderTable().clone();
        storage.exemplarListe = Entwurf.dataInteractor.getExemplarListe().map(e=>e.clone());
        storage.features = deepCopy(true, [], this.model.getCurrentOwayoProduct().selectedFeatures);

        this.setEntwurftransferStorage(storage)
        EventVerteiler.broadcast("giveMePartSizesEvent", output=>this.savePartSizeInfoInTransferStorage(output));
    }

    static setZOrderInStorage(selectableObjectArray:SelectableObject[]) {
        selectableObjectArray.forEach(selOb=>selOb.zOrder = Entwurf.dataInteractor.getZOrderTable().getZIndex(selOb.id));
    }

    extractInformationFromEntwurfForProductChange() {
        this.extractInformationFromEntwurfForProductChangeWithoutColors();
        this.getEntwurfTransferStorage().colorObjects = this.colorController.extractColorInfoFromEntwurf();
    }

    getInitialSession() {
        const $this = this;
        const callback = function(data) {
            const username = data.username;
            const loggedIn = data.logged_in === true;

            if (loggedIn === true) {
                EventVerteiler.broadcast("userLoggedInEvent", {username: username});
            }
            if (data.newSession === true) {
                Controller.resourceManager.createTask("doABarrelRoll").discardAfterExecution()
                    .when("designtexturesLoaded", "done")
                    .thenDo(()=>setTimeout(Controller.showThatModelRotates, 50))
            }
            if ($this.firstLoad === true) {
                Controller.resourceManager.createTask("display_logosIncl")
                    .discardAfterExecution()
                    .when("initViewComponent_owayoJSViewer", "done")
                    .thenDo(
                        ()=>{
                            $this.firstLoad = false;

                            if ($this.model.isOwayoDirectLogin() === true || $this.model.getDomain() === "localhost") {
                                return;
                            }
                            EventVerteiler.broadcast("displayLogosInclBannerEvent")
                        }
                    );
            }
            $this.model.user.setUserFromInitialSession(username, loggedIn);
            if(loggedIn === false) {
                if (existsLastLoggedInUserCookie()) {
                    EventVerteiler.broadcast("notLoggedInWithLastUserInCookieEvent");

                }
            }
            EventVerteiler.broadcast("initialSessionarrivedEvent");
            globalsObject.resourceManager.registerLoadedResourceWithoutData("initialSessionarrivedEvent");
        };
        SessionController.getInitialSession(callback, Controller.errorHandler, translate);
    }



    loadReadyDesign(ordertype, readyDesignID){
        globalsObject.resourceManager.executeInvalidation("loadnewrdydesign");
        ReadyDesignLoader.loadReadyDesign(this.model, ordertype, readyDesignID).then(()=>this.triggerShaderRebuildAfterrepaint());
    }

    logReadyDesign(readydesigncode:string, typ:string){
        const owayoProduct = this.model.getCurrentOwayoProduct();
        ReadyDesignLoader.logReadyDesign(readydesigncode, typ, owayoProduct.sportart, owayoProduct.productWebNormalized);
    }

    loadFacebookPost(fbPostID){
            ReadyDesignLoader.loadFacebookPost(this.model, fbPostID).then(()=>this.triggerShaderRebuildAfterrepaint());
    }

    // loadMotiv(motivID){
    //     this.selObController.deleteAllSelObs();
    //     MotivLoader.loadMotiv(this.model, motivID).then(()=>this.triggerShaderRebuildAfterrepaint());;
    // }

    // convertMotiv(){
    //     MotivConverter.convertPartSelObsToMotiv(this.model.entwurf.getTextObjects(), this.model.entwurf.getLogoObjects(), 'Front', this.model, this);
    // }

    private triggerShaderRebuildAfterrepaint() {
        setTimeout(()=>EventVerteiler.broadcast("recreateAllShadersEvent"), 20);
                }


    loadInitialProduct(isKundenKonfi, design, features) {
        // const $this = this;
        const data = {
            schnitt: this.infoFromGetParameters.productInfo.schnitt,
            sport: this.infoFromGetParameters.productInfo.sport.webNormalized,
            sportAnzeigeKategorie: this.infoFromGetParameters.productInfo.sport.webNormalized,
            websport:this.model.getWebsportFuerProduktAuswahlNormalized(),
            ordertype: this.infoFromGetParameters.productInfo.ordertype,
            webProduct: this.infoFromGetParameters.productInfo.product.webNormalized,
            iso: this.model.getLanguageIso(),
            produktAuwi: this.infoFromGetParameters.productInfo.product.auwi,
            showUnpublishedDesigns: this.infoFromGetParameters.owayoDirectLogin,
            features: JSON.stringify(features)
        };
        loadproduktPhpAndRegisterResource(data).then((data:Produktresponse)=>this.initInitialProduct(isKundenKonfi, design, features,data))
            // .catch(()=>console.log("error loading product"));
    }

    initInitialProduct(isKundenKonfi, design, features, dataFromProduktPHP:Produktresponse) {
        if (typeof (dataFromProduktPHP.Designs) === "undefined") { //z.B. Aufruf mit falschen Parametern
            // $("body").unblock();
            alert("Sorry, there are no designs avaiable for this product");
            throw new Error("keine designs für das Produkt verfügbar");
        }
        this.initProductFromServerData(dataFromProduktPHP, features);
        if (design === '') {
            design = this.model.getCurrentOwayoProduct().basisdesign;
        }
        if (isKundenKonfi) {
            this.isKundenKonfi = true;
            globalsObject.actionController.loadKundenKonfiVorbelegungsEntwurf(
                this.infoFromGetParameters.productInfo.design,
                {
                    productCategory: this.infoFromGetParameters.productInfo.product.webNormalized,
                    design: design,
                    model: this.model.getCurrentOwayoProduct().model
                }
            );

            EventVerteiler.broadcast(
                "updateTitelTagEvent",
                {
                    product: this.model.getCurrentOwayoProduct(),
                    design: design,
                    vorbelegungAmount: dataFromProduktPHP.VorbelegungPreisanzeige
                }
            );
            Controller.resourceManager.registerLoadedResourceWithoutData("loadInitialProduct")
            return;
        }

        this.isKundenKonfi = false;
        this.initNewEntwurf(this.infoFromGetParameters.productInfo.product.webNormalized,design,this.model.getCurrentOwayoProduct().model)

        if(this.infoFromGetParameters.showFeatures===true){
            Controller.resourceManager.createTask("openFeaturesAuswahl")
                .withContext(this)
                .invalidAfter(ResourceInvalidationTriggers.PRODUCTCHANGE)
                .when("produktAuswahl.php", "loaded").andWhen("initProduktAuswahl", "loaded")
                .thenDo(()=>{
                    //FIXME open FeatureAuswahl direkt

                    // PopupTools.openFeaturesPopup();
                    // globalsObject.productController.auswahlProdukteSelectFeatures(this.infoFromGetParameters.productInfo.product.webNormalized);
                });
        }

        EventVerteiler.broadcast(
            "updateTitelTagEvent",
            {
                product: this.model.getCurrentOwayoProduct(),
                design: design,
                vorbelegungAmount: dataFromProduktPHP.VorbelegungPreisanzeige
            }
        );
    }

    private static createProcuct(data:Produktresponse, features, websportNormalized) {
        const out = new Product(
            data.Produkt,
            data.Name,
            data.Cut,
            data.Ordertype,
            data.auwiSport,
            data.Designlist
        );
        out.initAdditionalInfos(data, websportNormalized, features);
        return out;
    }

    initProductFromServerData(data:Produktresponse, features) {
        this.model.setCurrentOwayoProduct(Controller.createProcuct(data, features, this.infoFromGetParameters.sportFuerProduktauswahl.webNormalized));

    }

    public getInternationalKonfiLinks(contentArray: ContentWithLevel[], callback?: (result)=>void) {
        if (this.model.getCurrentOwayoProduct() === null || this.model.getCurrentOwayoProduct() === undefined) {
            return;
        }
        const productToGetValuesFrom = this.model.getCurrentOwayoProduct();
        Linkersteller.getInternationalKonfiLinks({
            callback:callback as (result)=>void,
            land: this.model.getLand(),
            sportWebInt: this.model.getWebSportFuerProduktAuswahlInt() as string,
            sprache: this.model.getSprache(),
            contentArray,
            productWebInt:productToGetValuesFrom.productWebInt
        })
    }

    public getLoadDesignData(): { features: SelectedFeature[]; design: string; model: string; schnitt: any,herstellerlogosEntfernt:boolean } {
        return {
            // productCategory: this.model.entwurf.productCategory,
            design: this.model.entwurf.getDesign(),
            model: this.model.entwurf.getModel(),
            schnitt: this.model.getCurrentOwayoProduct().cut,
            features: this.model.getCurrentOwayoProduct().selectedFeatures,
            herstellerlogosEntfernt: this.model.entwurf.getHerstellerlogosDeleted()
        };
    }

    public getGroessenTabelle () {

        return new Promise<string>(resolve=>{
            const currentOwayoProduct = this.model.getCurrentOwayoProduct();
            const parameters = getGetParameterString(
                {
                    tab:"sizes",
                    landessprache:this.model.getSprache(),
                    sport:currentOwayoProduct.websportUnterDemDasProduktGehostetIstUebersetzt,
                    product:currentOwayoProduct.productWebInt,
                    content:currentOwayoProduct.productWebInt,
                    konfi:1
                }
            )
            axios.get(getURLPrefixOfflineVsOnline() + "/newhp/php/getTabContent.php?" + parameters).then((result)=>resolve(result.data))
        })
    }



    public changeDesign(newDesign:string, byHistoryController?:boolean) {
        const $this = this;
        const logosToDelete = owayoUtils.removeClonesFromArray(this.selObController.getLogoObjects().filter(l=>l.zuLoeschenBeiProduktUndDesignWechsel));
        if(byHistoryController !== true) {
            EventVerteiler.broadcast("aboutToChangeDesignEvent", {oldDesign:this.model.entwurf.getDesign(), newDesign, logosThatWillBeDeleted:logosToDelete})
            logosToDelete.forEach(l=>this.selObController.deleteSelOb(l.id, true, "designchange"));
        }
        if (newDesign === this.model.entwurf.getDesign()) {
            return;
        }
        this.getEntwurfTransferStorage().vorbelegungsChromoLogoColors = this.selObController.getChromoLogoColorsForTransferStorage();
        this.model.entwurf.setChangedSinceSave(true);
        EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_CLEARED);
        EventVerteiler.broadcast("designSelectedEvent", {design:newDesign});


        //ColorObjects nicht löschen! diese werden ggfs später überschrieben und auf visible gesetzt
        this.model.entwurf.setDesignname(newDesign);
        this.model.entwurf.updateColorCodes(
            this.model.getCurrentOwayoProduct().colorCodes,
            this.model.getCurrentOwayoProduct().ColorCodeFarbVorbelegungen,
            arrayElementByKeyValue(this.model.getCurrentOwayoProduct().possibleDesigns, "Design", newDesign).ColorCodeAbhaengigkeiten,
            this.model.getCurrentOwayoProduct().farbBeziehungenZwischenColorCodes
        );
        this.colorController.setColorVisibleStatus();
        this.colorController.setColorsToColorCodeAliases();
        Controller.resourceManager.checkTasksAndExecute();
        EventVerteiler.broadcast("loadDesignEvent", this.getLoadDesignData());
        EventVerteiler.broadcast("updateTitelTagEvent", {product:this.model.getCurrentOwayoProduct(), design:newDesign});
        this.trackpageView("konfiaccess/3Ddesigngeaendert.htm");
        globalsObject.loopTracker.trackSelectDesignEvent(this.model.getCurrentOwayoProduct().designList, newDesign);

        this.selObController.deleteVorbelegungsSelObs();
        EventVerteiler.broadcast(SELOBEVENTNAMES.LOAD_KK_VORBELEGUNGSSELOBS, function(){$this.selObController.insertVorbelegungsSelObs();});
    }

    public getPossibleDesignnames() {
        if(this.model.getCurrentOwayoProduct() === null) {
            return [];
        }
        const filtered = this.model.getCurrentOwayoProduct().possibleDesigns.filter(d=>parseInt(d.KonfiDiscarded) ===0);
        return filtered.map(d => d.Design);
    }

    private einzelexemplareChanged(saveID: string, exemplare: EinzelExemplar[]) {
        if(this.model.entwurf.getID() === saveID) {
            this.model.entwurf.setExemplarListe(exemplare);
        }
    }

    public getColorValueForColorCode(colorcode:string) {
        const filtered = this.model.entwurf.getColorObjects().filter(c=>c.colorCode === colorcode);
        if(filtered.length === 0) {
            return "";
        }
        return filtered[0].colorValue;
    }

    public getColorCodeNr = (colorcodeString:string)=>this.model.entwurf.getColorCodeNr(colorcodeString);
    public getColorCodeFromColorCodeNr = (nr:number)=>this.model.entwurf.getColorCodeFromColorCodeNr(nr);

    colorCodeNrHasPattern(colorCodeNr:number) {
         return this.patternController.colorCodeHasPattern(colorCodeNr);
    }

    getColorCodeNumbersOfAliases(colorCodeNr:number) {
        return this.colorController.getColorCodeNumbersOfAliases(colorCodeNr)
    }

    private deleteFromSelObArrayIfOnInvisblePart(selObs:SelectableObject[], invisiblePartNames:string[]) {
        selObs.forEach(s=> {
            if (invisiblePartNames.indexOf(s.partName) > -1) {
                this.selObController.deleteSelOb(s.id);
            }
        });
    }

    private deleteSelectableObjectsOnInvisibleParts(invisiblePartNames: string[]) {
        [this.model.entwurf.getTextObjects() as TextObject[], this.model.entwurf.getLogoObjects()]
            .forEach((selObs:SelectableObject[])=>this.deleteFromSelObArrayIfOnInvisblePart(selObs, invisiblePartNames));
    }
}
